import is from './locales/is.json';

// English is the default message in each of our source files, so no need for a separate en.json file
const en = {};

export default { en, is};
